import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DadosEmpresaService {

  private params: HttpParams;

  constructor(private readonly http: HttpClient) { }

  // FUNÇÕES DA ABA DADOS DA EMPRESA
  getDadosEmpresa(idEmpresaLogada: string) {
    const url = `/apiconnect/importation/company/data/${idEmpresaLogada}/companies`;

    return this.http.get(url);
  }

  updateDadosEmpresa(idEmpresaLogada: string, body: any) {
    const url = `/apiconnect/importation/company/${idEmpresaLogada}/companies`;

    return this.http.patch(url, body);
  }

  getRamosAtividades() {
    const url = `/apiconnect/importation/company/activity-branchs`;

    return this.http.get(url);
  }

  // FUNÇÃO DA ABA FILIAIS

  getFiliais(idEmpresa: string) {
    const url = `/apiconnect/importation/company/affiliate/list/${idEmpresa}/companies`;

    return this.http.get(url);
  }

  createNewFilial(idEmpresaPai: string, body: any) {
    const url = `/apiconnect/importation/company/affiliate/new/${idEmpresaPai}/companies`;

    return this.http.post(url, body);
  }

  deleteFilial(idEmpresaDeletada: number) {
    const url = `/apiconnect/importation/company/affiliate/${idEmpresaDeletada}/companies`;

    return this.http.delete(url);
  }

  // FUNÇÕES DA ABA ENDEREÇOS
  consultaDadosEndereco(idEmpresa: string, idEndereco: string) {
    const url = `/apiconnect/importation/billing-address/data/${idEmpresa}/companies?idEndereco=${idEndereco}`;

    return this.http.get(url);
  }

  inactivateEndereco(idEmpresa: string, idEndereco: number) {
    // Troquei essa URL mas falta verificar com o backEnd se essa é a correta (do API connect)
    const url = `/apiconnect/importation/company/${idEmpresa}/companies/${idEndereco}/addressess`;

    return this.http.delete(url);
  }

  consultaCep(cep: string) {
    const url = `/apiconnect/importation/billing-address/${cep}`;

    return this.http.post(url, '');
  }

  createNewEndereco(idEmpresa: string, body: any) {
    const url = `/apiconnect/importation/billing-address/data/${idEmpresa}/companies`;

    return this.http.post(url, body);
  }

  getEnderecosInativos(idEmpresa: number) {
    const url = `/apiconnect/importation/company/inactive-address/${idEmpresa}/companies`;

    return this.http.get(url);
  }

  activateEndereco(idEmpresa: number, idEndereco: number) {
    const url = `/apiconnect/core/companies/${idEmpresa}/inactive-addresses/${idEndereco}`;

    return this.http.delete(url);
  }

  updateEndereco(body: any) {
    const url = `/apiconnect/importation/billing-address`;

    return this.http.post(url, body);
  }

  // FUNÇÕES DA ABA DE CONTATOS

  getDadosContato(idContato: string) {
    const url = `/apiconnect/orders/contacts/data/${idContato}/contacts`;

    return this.http.get(url);
  }

  deleteContato(idEmpresa: string, idContato: number) {
    this.setParameterPortalUser('userUpdateId');
    const url = `/apiconnect/importation/contacts?idContato=${idContato}&idEmpresa=${idEmpresa}`;
    return this.http.delete(url, { params: this.params });
  }

  consultaDepartamentos() {
    const url = `/apiconnect/importation/departament`;

    return this.http.get(url);
  }

  consultaCargos() {
    const url = `/apiconnect/importation/responsibility`;

    return this.http.get(url);
  }

consultaPrimeiroPedido(idEmpresa: number){
    return this.http.get(`/apiconnect/orders/companies/${idEmpresa}/first-orders`);
  }

  private setParameterPortalUser(parameterName: string) {
    const portalUserId = localStorage.portalUserId;
    if (portalUserId !== undefined) {
      const obj = {}
      obj[parameterName] = portalUserId;
      this.params = new HttpParams({fromObject: obj});
    }
  }


}
